
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line

/**
 * ExportModuleSyncStatus enum
 */
class ExportModuleSyncStatus {
  /**
   * Initialize enum with a given value
   * @param {ExportModuleSyncStatus|number|Int64|UInt64=} value Enum value, defaults is 0
   * @constructor
   */
  constructor (value = 0) {
    if (value instanceof ExportModuleSyncStatus) {
      this.value = value.value
    } else {
      this.value = value
    }
  }

  /**
   * Is this enum equal to other one?
   * @this {!ExportModuleSyncStatus}
   * @param {!ExportModuleSyncStatus} other Other enum
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof ExportModuleSyncStatus)) {
      throw new TypeError('Instance of ExportModuleSyncStatus is required!')
    }
    return this.value === other.value
  }

  /**
   * Get enum value
   * @this {!ExportModuleSyncStatus}
   * @returns {!number|!Int64|!UInt64} Enum value
   */
  valueOf () {
    return this.value
  }

  /**
   * Convert enum to string
   * @this {!ExportModuleSyncStatus}
   * @returns {!string} Enum value string
   */
  toString () {
    if (this.value === ExportModuleSyncStatus.DISABLED.value) {
      return 'DISABLED'
    }
    if (this.value === ExportModuleSyncStatus.ERROR.value) {
      return 'ERROR'
    }
    if (this.value === ExportModuleSyncStatus.IN_PROGRESS.value) {
      return 'IN_PROGRESS'
    }
    if (this.value === ExportModuleSyncStatus.UP_TO_DATE.value) {
      return 'UP_TO_DATE'
    }
    return '<unknown>'
  }

  /**
   * Inspect enum
   * @this {!ExportModuleSyncStatus}
   * @returns {!string} Enum value string
   */
  [util.inspect.custom] () {
    return this.toString()
  }

  /**
   * Convert enum to JSON
   * @this {!ExportModuleSyncStatus}
   * @returns {!number} Enum value for JSON
   */
  toJSON () {
    return this.value
  }

  /**
   * Create enum from object value
   * @param {!number} other Object value
   * @returns {!ExportModuleSyncStatus} Created enum
   */
  static fromObject (other) {
    return new ExportModuleSyncStatus(other)
  }
}

// noinspection PointlessArithmeticExpressionJS
ExportModuleSyncStatus.DISABLED = new ExportModuleSyncStatus(0 + 0)
// noinspection PointlessArithmeticExpressionJS
ExportModuleSyncStatus.ERROR = new ExportModuleSyncStatus(0 + 1)
// noinspection PointlessArithmeticExpressionJS
ExportModuleSyncStatus.IN_PROGRESS = new ExportModuleSyncStatus(0 + 2)
// noinspection PointlessArithmeticExpressionJS
ExportModuleSyncStatus.UP_TO_DATE = new ExportModuleSyncStatus(0 + 3)

export { ExportModuleSyncStatus };

/**
 * Fast Binary Encoding ExportModuleSyncStatus field model
 */
class FieldModelExportModuleSyncStatus extends fbe.FieldModel {
  /**
   * Get the field size
   * @this {!FieldModelExportModuleSyncStatus}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the value
   * @this {!FieldModelExportModuleSyncStatus}
   * @param {ExportModuleSyncStatus=} defaults Default value, defaults is new ExportModuleSyncStatus()
   * @returns {!ExportModuleSyncStatus} Result value
   */
  get (defaults = new ExportModuleSyncStatus()) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return defaults
    }

    return new ExportModuleSyncStatus(this.readInt32(this.fbeOffset))
  }

  /**
   * Set the value
   * @this {!FieldModelExportModuleSyncStatus}
   * @param {!ExportModuleSyncStatus} value Value
   */
  set (value) {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return
    }

    this.writeInt32(this.fbeOffset, value.value)
  }
}

export { FieldModelExportModuleSyncStatus };
